// extracted by mini-css-extract-plugin
export var table = "_vm-0";